<template>
  <v-dialog v-model="show" scrollable width="50%" persistent>
    <v-card>
      <Toolbar
        title="Szabályozó módosítása"
        btn-title="Módosítás"
        @btnClicked="updateRegulator"
        @close="reset"
      />

      <v-card-text class="pt-3">
        <v-form>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Szabályozó neve"
                  v-model="regulator.name"
                  clearable
                  :error-messages="getErrorMessage('name')"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-switch
                  label="Aktív"
                  v-model="regulator.is_active"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditRegulatorModal",
  computed: {
    ...mapGetters("Modal", {
      show: "showEditModal"
    }),
    ...mapGetters("Regulator", ["regulator"]),
    ...mapGetters(["getErrorMessage"])
  },
  methods: {
    ...mapActions("Regulator", ["updateRegulator", "reset"])
  }
};
</script>

<style></style>
